import React, { useState, useEffect } from 'react'
import SHA256 from 'crypto-js/sha256'
import './PasswordAuth.css'

interface PasswordAuthProps {
  onSuccess: () => void
  pageName: string
}

const PasswordAuth: React.FC<PasswordAuthProps> = ({ onSuccess, pageName }) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  // ハッシュ化されたパスワード (hhbm2025 -> SHA256)
  const ADMIN_PASSWORD_HASH = '400413eeef9eee0855d82c6f9e010ffd3a5b4ba15a38708be599ba7806f183d8'

  // セッション有効期限 (30分)
  const SESSION_TIMEOUT = 30 * 60 * 1000

  useEffect(() => {
    const savedAuth = sessionStorage.getItem(`hep5_auth_${pageName}`)
    const savedTimestamp = sessionStorage.getItem(`hep5_auth_timestamp_${pageName}`)

    if (savedAuth === 'true' && savedTimestamp) {
      const sessionTime = parseInt(savedTimestamp)
      const now = Date.now()

      // セッション有効期限チェック
      if (now - sessionTime < SESSION_TIMEOUT) {
        // セッション更新
        sessionStorage.setItem(`hep5_auth_timestamp_${pageName}`, now.toString())
        onSuccess()
      } else {
        // セッション期限切れ
        sessionStorage.removeItem(`hep5_auth_${pageName}`)
        sessionStorage.removeItem(`hep5_auth_timestamp_${pageName}`)
      }
    }
  }, [onSuccess, pageName, SESSION_TIMEOUT])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError('')

    await new Promise(resolve => setTimeout(resolve, 500))

    // 入力されたパスワードをハッシュ化
    const inputHash = SHA256(password).toString()

    if (inputHash === ADMIN_PASSWORD_HASH) {
      const now = Date.now()
      sessionStorage.setItem(`hep5_auth_${pageName}`, 'true')
      sessionStorage.setItem(`hep5_auth_timestamp_${pageName}`, now.toString())
      onSuccess()
    } else {
      setError('パスワードが正しくありません')
      setPassword('')
    }
    setIsSubmitting(false)
  }

  return (
    <div className="password-auth-overlay">
      <div className="password-auth-container">
        <div className="auth-icon">🔐</div>
        <h2>{pageName}ページ</h2>
        <p>このページにアクセスするにはパスワードが必要です</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <label htmlFor="password">パスワード:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="パスワードを入力してください"
              disabled={isSubmitting}
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              ❌ {error}
            </div>
          )}

          <button
            type="submit"
            className="auth-button"
            disabled={isSubmitting || !password.trim()}
          >
            {isSubmitting ? '認証中...' : 'ログイン'}
          </button>
        </form>

        <div className="auth-footer">
          <small>
            セッションは30分間有効です<br />
            パスワードはハッシュ化して保護されています
          </small>
        </div>
      </div>
    </div>
  )
}

export default PasswordAuth